import { useState } from 'react';
import { api } from '../api.js';

/** Your own password. */
export function Account({ user }) {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const mismatch = form.confirm.length > 0 && form.newPassword !== form.confirm;
  const ready = form.currentPassword && form.newPassword.length >= 12 && !mismatch;

  const submit = async () => {
    setBusy(true); setErr(null); setMsg(null);
    try {
      await api.post('/api/users/change-password', {
        currentPassword: form.currentPassword, newPassword: form.newPassword,
      });
      setMsg('Password changed. Your other sessions stay signed in until they expire.');
      setForm({ currentPassword: '', newPassword: '', confirm: '' });
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <header className="rhead">
        <h1 className="rhead__title display">Your password</h1>
        <div className="rhead__sub">Signed in as {user?.fullName} · {user?.email}</div>
      </header>

      {err && <div className="error">{err}</div>}
      {msg && <div className="ok">{msg}</div>}

      <div style={{ maxWidth: 380 }}>
        <label className="field" style={{ marginBottom: 12 }}><span>Current password</span>
          <input type="password" value={form.currentPassword} autoComplete="current-password"
                 onChange={set('currentPassword')} /></label>
        <label className="field" style={{ marginBottom: 4 }}><span>New password</span>
          <input type="password" value={form.newPassword} autoComplete="new-password"
                 onChange={set('newPassword')} /></label>
        <div style={{ fontSize: 12, color: 'var(--ink-faint)', marginBottom: 12 }}>
          At least 12 characters.
        </div>
        <label className="field" style={{ marginBottom: 4 }}><span>Confirm new password</span>
          <input type="password" value={form.confirm} autoComplete="new-password"
                 onChange={set('confirm')} /></label>
        {mismatch && <div style={{ fontSize: 12, color: 'var(--unbalanced)', marginBottom: 8 }}>
          Those do not match.
        </div>}

        <button className="btn" style={{ marginTop: 12 }} onClick={submit} disabled={!ready || busy}>
          {busy ? 'Saving' : 'Change password'}
        </button>
      </div>
    </>
  );
}
